export default function Footer() {
  return (
    <>
      <footer>
        <div>
          Copyright © 2021 Sarvar Khalimov
          <a className="icon-link" href="https://github.com/SarvarKh" target="_blank" rel="noreferrer">
            <i className="fab fa-github" aria-hidden="true" />
          </a>
          <a className="icon-link" href="https://www.linkedin.com/in/sarvar-khalimov/" target="_blank" rel="noreferrer">
            <i className="fab fa-linkedin" aria-hidden="true" />
          </a>
          <a className="icon-link" href="https://sarvarkh.github.io/portfolio/" target="_blank" rel="noreferrer">
            <i className="fas fa-folder-open" aria-hidden="true" />
          </a>
        </div>
      </footer>
    </>
  );
}
